function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import AlignMixin from '../../mixins/align.js';
import { slot } from '../../utils/slot.js';
import ListenersMixin from '../../mixins/listeners.js';
var disabledValues = [true, ''];
export default Vue.extend({
  name: 'QBreadcrumbs',
  mixins: [ListenersMixin, AlignMixin],
  props: {
    separator: {
      type: String,
      "default": '/'
    },
    separatorColor: String,
    activeColor: {
      type: String,
      "default": 'primary'
    },
    gutter: {
      type: String,
      validator: function validator(v) {
        return ['none', 'xs', 'sm', 'md', 'lg', 'xl'].includes(v);
      },
      "default": 'sm'
    }
  },
  computed: {
    classes: function classes() {
      return "".concat(this.alignClass).concat(this.gutter === 'none' ? '' : " q-gutter-".concat(this.gutter));
    },
    sepClass: function sepClass() {
      return this.separatorColor ? " text-".concat(this.separatorColor) : '';
    },
    activeClass: function activeClass() {
      return " text-".concat(this.activeColor);
    }
  },
  render: function render(h) {
    var _this = this;

    var nodes = slot(this, 'default');

    if (nodes === void 0) {
      return;
    }

    var els = 1;
    var child = [],
        len = nodes.filter(function (c) {
      return c.tag !== void 0 && c.tag.endsWith('-QBreadcrumbsEl');
    }).length,
        separator = this.$scopedSlots.separator !== void 0 ? this.$scopedSlots.separator : function () {
      return _this.separator;
    };
    nodes.forEach(function (comp) {
      if (comp.tag !== void 0 && comp.tag.endsWith('-QBreadcrumbsEl')) {
        var middle = els < len;
        var disabled = disabledValues.includes(comp.componentOptions.propsData.disable);
        var cls = middle === true ? disabled !== true ? _this.activeClass : '' : ' q-breadcrumbs--last';
        els++;
        child.push(h('div', {
          staticClass: 'flex items-center' + cls
        }, [comp]));
        middle === true && child.push(h('div', {
          staticClass: 'q-breadcrumbs__separator' + _this.sepClass
        }, separator()));
      } else {
        child.push(comp);
      }
    });
    return h('div', {
      staticClass: 'q-breadcrumbs',
      on: _objectSpread({}, this.qListeners)
    }, [h('div', {
      staticClass: 'flex items-center',
      "class": this.classes
    }, child)]);
  }
});